import React, { Component } from 'react';
import { FeaturedEventCard, LoadingCard } from '../../cards';

class FeaturedEvents extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { featuredEvents = [] } = this.props;

        return (
            <div className="container">
                <div className={`hp-spacing`}>
                    <div className={`hp-title`}>
                        Featured Events
                    </div>
                    {featuredEvents && featuredEvents.length ? (
                        <div className="row">
                            {featuredEvents.map((featuredItem, i) => {
                                return (
                                    <div className={`col-12 col-md-6`} key={`featuredEvent-${i}`}>
                                        <FeaturedEventCard
                                            event={featuredItem.item}
                                            force={
                                                { hideRegisteredCount: true }
                                            }
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="row">
                            <div className={`col-12 col-md-6`}>
                                <LoadingCard />
                            </div>
                            <div className={`d-none d-md-block col-md-6`}>
                                <LoadingCard />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FeaturedEvents;
